export enum SituationKey {
  COMFORTABLE_USING_TECHNOLOGY = 'comfortable_using_technology',
  NET_VALUE_BELOW_250K = 'net_value_below_250k',
  SEPARATED_OR_DIVORCED = 'separated_or_divorced',
  BLENDED_FAMILY = 'blended_family',
  DISABILITIES = 'disabilities',
  ASSETS_MULTIPLE_PROVINCES = 'assets_multiple_provinces',
  OWN_RECREATIONAL_PROPERTY = 'own_recreational_property',
  OWN_RENTAL_REAL_ESTATE = 'own_rental_real_estate',
  INCORPORATE_OR_OWN_PRIVATE_SHARES = 'incorporate_or_own_private_shares',
  ACTIVE_FARM_OR_MINING_PROPERTY = 'active_farm_or_mining_property',
  OWN_OR_OPERATE_COMPLEX_BUSINESS_OR_CORPORATE_STRUCTURE = 'own_or_operate_complex_business_or_corporate_structure',
  LOVED_ONES_NOT_IN_SAME_PROVINCE = 'loved_ones_not_in_same_province'
}
